<template>
  <div class="pre-register">
    <fieldset class="ba b--transparent ph0 mh0 tl">
      <legend class="f4 fw6 ph0 mh0 mb4">Empieza aquí</legend>
      <div class="flex flex-wrap nl3 nr3 mb3 mb4-l lh-copy">
        <div class="w-100 w-third-l ph3 mb3 mb0-l">
          <ValidationProvider
            name="nombre"
            rules="required"
            vid="Nombre"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Nombre<span class="red">*</span>
              <input
                type="text"
                v-model="preData.nombre"
                :class="classes"
                class="db mt2 pa2 ba input-reset b--moon-gray w-100"
              />
              <div class="f6 red fw3">{{ errors[0] }}</div>
            </label>
          </ValidationProvider>
        </div>
        <div class="w-100 w-third-l ph3">
          <ValidationProvider
            name="fechaNacimiento"
            rules="required"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Fecha de nacimiento<span class="red">*</span>
              <flat-pickr
                v-model="preData.fechaNacimiento"
                class="db mt2 pa2 ba input-reset b--moon-gray w-100"
                :class="classes"
                :config="configFlatPicker"
              ></flat-pickr>
            </label>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="w-100 w-third-l ph3 mb3 mb0-l">
          <ValidationProvider
            name="telefono"
            rules="required|digits:10"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Cel. de contacto<span class="red">*</span>
              <input
                type="text"
                v-model="preData.tel"
                :class="classes"
                maxlength="10"
                pattern="[0-9]{10}"
                class="db mt2 pa2 ba input-reset b--moon-gray w-100"
              />
              <div class="f6 red fw3">{{ errors[0] }}</div>
            </label>
          </ValidationProvider>
        </div>
      </div>
      <div class="flex flex-wrap nl3 nr3 mb3 mb4-l lh-copy"></div>
      <div class="flex flex-wrap nl3 nr3 mb3 mb4-l lh-copy">
        <div class="w-100 w-60-l ph3 mb3 mb0-l">
          <ValidationProvider
            name="modalidad"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="mb2 fw3">
              ¿Cuál es tu modalidad de trabajo?<span class="red">*</span>
            </div>
            <label
              class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1"
            >
              <input v-model="preData.modalidad" type="radio" value="Planta" />
              Planta
            </label>
            <label
              class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1"
            >
              <input
                v-model="preData.modalidad"
                type="radio"
                value="Entrada por salida"
              />
              Entrada por salida
            </label>
            <label class="f6 b--light-gray ba bg-light-gray br3 dib fw3 pa1">
              <input v-model="preData.modalidad" type="radio" value="Ambas" />
              Ambas
            </label>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="w-100 w-40-l ph3 mb3 mb0-l">
          <ValidationProvider
            name="genero"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="mb2 fw3">Genero<span class="red">*</span></div>
            <label
              class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1"
            >
              <input v-model="preData.genero" type="radio" value="Masculino" />
              Masculino
            </label>
            <label class="f6 b--light-gray ba bg-light-gray br3 dib fw3 pa1">
              <input v-model="preData.genero" type="radio" value="Femenino" />
              Femenino
            </label>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
      </div>
      <div class="flex flex-wrap nl3 nr3 mb3 mb4-l lh-copy">
        <div class="w-100 w-50-l ph3 mb3 mb0-l">
          <ValidationProvider
            name="perfil"
            rules="required"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Perfil que busca trabajo<span class="red">*</span>
              <select
                v-model="preData.perfil"
                :class="classes"
                class="db mt2 pa2 ba b--moon-gray w-100"
              >
                <option
                  v-for="job in jobs[preData.genero]"
                  v-bind:key="job.value"
                >
                  {{ job.text }}
                </option>
              </select>
            </label>
            <p class="mb0 mt2 f6 fw3 dark-gray">
              El trabajo a realizar es de Lunes a Sábado
            </p>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="w-100 w-50-l ph3 mb3 mb0-l">
          <ValidationProvider
            name="ciudadTrabajo"
            rules="required"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Ciudad que quiere trabajar<span class="red">*</span>
              <select
                v-model="preData.ciudadTrabajo"
                :class="classes"
                class="db mt2 pa2 ba b--moon-gray w-100"
              >
                <option value="CDMX">Ciudad de México</option>
                <option value="GDL">Guadalajara</option>
              </select>
            </label>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
      </div>
      <div class="mb3 mb4-l lh-copy">
        <div class="fw3 mb2">
          ¿Con que documentos cuentas?<span class="red">*</span>
        </div>
        <ValidationProvider
          name="documentos"
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }"
        >
          <div class="mb2">
            <label class="fw3">
              <input
                type="checkbox"
                v-model="documentos"
                @change="getDocs"
                value="INE"
              />
              INE
            </label>
          </div>
          <div class="mb2">
            <label class="fw3">
              <input
                type="checkbox"
                v-model="documentos"
                @change="getDocs"
                value="Pasaporte"
              />
              Pasaporte
            </label>
          </div>
          <div class="mb2">
            <label class="fw3">
              <input
                type="checkbox"
                v-model="documentos"
                @change="getDocs"
                value="Acta de Nacimiento"
              />
              Acta de Nacimiento
            </label>
          </div>
          <div>
            <label class="fw3">
              <input
                type="checkbox"
                v-model="documentos"
                @change="getDocs"
                value="Comprobante de tu domicilio vigente donde vives actualmente"
              />
              Comprobante de tu domicilio vigente donde vives actualmente
            </label>
          </div>
          <div class="f6 red fw3">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="mb3 mb4-l lh-copy">
        <div class="fw3 mb2">
          ¿Cuentas con experiencia comprobable como {{ preData.perfil }}?<span
            class="red"
            >*</span
          >
        </div>
        <ValidationProvider
          name="experiencia"
          rules="required"
          v-slot="{ errors }"
        >
          <div class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1">
            <label>
              <input
                type="radio"
                v-model="preData.experiencia"
                value="Menos de 6 meses"
              />
              Menos de 6 meses
            </label>
          </div>
          <div class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1">
            <label>
              <input
                type="radio"
                v-model="preData.experiencia"
                value="Entre 1 y 3 años"
              />
              Entre 1 y 3 años
            </label>
          </div>
          <div class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1">
            <label>
              <input
                type="radio"
                v-model="preData.experiencia"
                value="Más de 3 años"
              />
              Más de 3 años
            </label>
          </div>
          <div class="f6 red fw3">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="flex flex-wrap nl3 nr3 mb3 mb4-l lh-copy">
        <div class="b mb3 w-100 ph3">Datos Domiciliarios</div>
        <div class="w-100 w-50-l ph3 mb3">
          <ValidationProvider
            name="estado"
            rules="required"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Estado<span class="red">*</span>
              <select
                v-model="preData.domicilio.estado"
                :class="classes"
                class="db mt2 pa2 ba b--moon-gray w-100"
              >
                <option v-for="state in states" v-bind:key="state.clave">{{
                  state.nombre
                }}</option>
              </select>
            </label>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="w-100 w-50-l ph3 mb3">
          <ValidationProvider
            name="municipio"
            rules="required"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Municipio<span class="red">*</span>
              <select
                v-model="preData.domicilio.municipio"
                :class="classes"
                class="db mt2 pa2 ba b--moon-gray w-100"
              >
                <template v-for="(town, name) in towns">
                  <template v-if="name == preData.domicilio.estado">
                    <option v-for="city in town" v-bind:key="city">{{
                      city
                    }}</option>
                  </template>
                </template>
              </select>
            </label>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
      </div>
      <div class="flex flex-wrap lh-copy mb3 mb4-l nl3 nr3">
        <div class="b mb3 mh3 w-100 bb pb2">
          Referencias laboral como {{ preData.perfil }}
        </div>
        <div class="ph3 w-100 w-60-l mb3">
          <div class="fw1 mb2">Lugar de trabajo<span class="red">*</span></div>
          <ValidationProvider
            name="primera.lugarDeTrabajo"
            rules="required"
            v-slot="{ errors }"
          >
            <div>
              <label
                class="f6 b--light-gray ba bg-light-gray br3 dib fw3 mr2 pa1"
              >
                <input
                  type="radio"
                  v-model="preData.referenciasLaborales.primera.lugarDeTrabajo"
                  value="Empresa"
                />
                Empresa
              </label>
              <label class="f6 b--light-gray ba bg-light-gray br3 dib fw3 pa1">
                <input
                  type="radio"
                  v-model="preData.referenciasLaborales.primera.lugarDeTrabajo"
                  value="Casa Particular"
                />
                Casa Particular
              </label>
            </div>
            <div class="f6 red fw3">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="ph3 w-100 w-40-l mb3">
          <ValidationProvider
            name="primera.sueldo"
            rules="required"
            v-slot="{ classes, errors }"
          >
            <label class="fw3">
              Sueldo Mensual<span class="red">*</span>
              <input
                type="number"
                v-model="preData.referenciasLaborales.primera.sueldo"
                :class="classes"
                class="db mt2 pa2 ba input-reset b--moon-gray w-100"
              />
              <div class="f6 red fw3">{{ errors[0] }}</div>
            </label>
          </ValidationProvider>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from 'flatpickr/dist/l10n/es'
import 'flatpickr/dist/flatpickr.css'
import statesJson from '@/assets/data/estados.json'
import townsJson from '@/assets/data/estados-municipios.json'

export default {
  name: 'PreRegister',
  props: ['preData'],
  components: {
    flatPickr
  },
  data() {
    return {
      configFlatPicker: {
        locale: Spanish
      },
      documentos: [],
      docs: '',
      jobs: {
        Femenino: [
          { text: 'Doméstica', value: 'Doméstica' },
          { text: 'Doméstica Niñera', value: 'Doméstica Niñera' },
          { text: 'Doméstica Cocinera', value: 'Doméstica Cocinera' },
          { text: 'Niñera', value: 'Niñera' },
          { text: 'Niñera con estudios', value: 'Niñera con estudios' },
          { text: 'Niñera con experiencia', value: 'Niñera con experiencia' },
          { text: 'Niñera Bilingüe', value: 'Niñera Bilingüe' },
          { text: 'Cocinera', value: 'Cocinera' },
          { text: 'Cocinera Intermedia', value: 'Cocinera Intermedia' },
          { text: 'Cuidadora', value: 'Cuidadora' },
          { text: 'Cuidadora Doméstica', value: 'Cuidadora Doméstica' },
          { text: 'Ama de llaves', value: 'Ama de llaves' },
          { text: 'Enfermera', value: 'Enfermera' }
        ],
        Masculino: [
          { text: 'Chofer', value: 'Chofer' },
          { text: 'Mozo', value: 'Mozo' },
          { text: 'Chef', value: 'Chef' }
        ]
      },
      states: statesJson,
      towns: townsJson
    }
  },
  methods: {
    getDocs() {
      this.preData.docs = this.documentos
    }
  }
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
